import { ParticipantTeam } from '../../../types/firestore/Game/Tournament/Participant';
import { MatchFactory } from './MatchFactory';
import { DEFAULT_COHORT_SIZE, EliminationPairer } from './EliminationPairer';
import {
  MatchAggregated,
  Round,
} from '../../../types/firestore/Game/Tournament/Bracket';
import { Required } from 'utility-types';
import { LinkedListUtil } from './LinkedListUtil';
import { TournamentBuilder } from '../TournamentBuilder';
import { shuffleSeeded } from '../../../util/randomSeeded';
//import { log } from '../../../util/log';
import { RoundFactory } from './RoundFactory';
import { EliminationTournament } from './EliminationTournament';

//@log
export class SingleElimination extends EliminationTournament {
  public constructor(
    matchFactory: MatchFactory = new MatchFactory(),
    roundFactory: RoundFactory = new RoundFactory(),
    private readonly cohortSize: number = DEFAULT_COHORT_SIZE,
  ) {
    super(matchFactory, roundFactory);
  }

  public static async bracket(tournamentBuilder: TournamentBuilder) {
    const { tournament, participants } = tournamentBuilder;
    const { bracketType, payouts } = tournament;
    if (bracketType === 'heats') {
      return [];
    }
    const randomSeed = await tournamentBuilder.randomSeed();
    const participantsShuffled = shuffleSeeded(participants, randomSeed);
    if (participantsShuffled.length < 2) {
      return [];
    }
    const singleElimination = new SingleElimination(
      undefined,
      new RoundFactory({
        payouts,
      }),
    );
    return singleElimination.buildBracket(participantsShuffled);
  }

  public async buildBracket(
    participants: ParticipantTeam[],
  ): Promise<Required<Round, 'matches'>[]> {
    const initialRound = this.buildInitialRound(participants);
    return SingleElimination.tieRounds(
      this.germinateBracket(
        initialRound,
        Math.log2(initialRound.matches.length) + 1,
      ),
    );
  }

  public buildInitialRound(
    participants: ParticipantTeam[],
  ): Required<Round, 'matches'> {
    const pairer = new EliminationPairer(participants, {
      cohortSize: this.cohortSize,
    });
    const matchesInitial = pairer.pair();

    return this.roundFactory.build(matchesInitial);
  }

  protected nextMatches(matches: MatchAggregated[]): MatchAggregated[] {
    return [...Array(matches.length / 2).keys()]
      .map((i) => i * 2)
      .map((i) => {
        const match1 = matches[Number(i)];
        const match2 = matches[i + 1];

        const matchNext = this.matchFactory.build(match1.winner, match2.winner);

        LinkedListUtil.tieCoalesce(match1, match2, matchNext);

        return matchNext;
      });
  }
}
